__turbopack_context__.v({
  "card": "CardRecommendBranch-module-scss-module__YzlDOq__card",
  "card_badge_area": "CardRecommendBranch-module-scss-module__YzlDOq__card_badge_area",
  "card_compact": "CardRecommendBranch-module-scss-module__YzlDOq__card_compact",
  "card_image": "CardRecommendBranch-module-scss-module__YzlDOq__card_image",
  "card_image_area": "CardRecommendBranch-module-scss-module__YzlDOq__card_image_area",
  "card_info": "CardRecommendBranch-module-scss-module__YzlDOq__card_info",
  "card_location": "CardRecommendBranch-module-scss-module__YzlDOq__card_location",
  "card_more": "CardRecommendBranch-module-scss-module__YzlDOq__card_more",
  "card_name": "CardRecommendBranch-module-scss-module__YzlDOq__card_name",
  "card_sub_title": "CardRecommendBranch-module-scss-module__YzlDOq__card_sub_title",
  "card_theme_primary": "CardRecommendBranch-module-scss-module__YzlDOq__card_theme_primary",
  "card_theme_secondary": "CardRecommendBranch-module-scss-module__YzlDOq__card_theme_secondary",
  "card_title_box": "CardRecommendBranch-module-scss-module__YzlDOq__card_title_box",
  "info_dd": "CardRecommendBranch-module-scss-module__YzlDOq__info_dd",
  "info_detail": "CardRecommendBranch-module-scss-module__YzlDOq__info_detail",
  "info_detail_item": "CardRecommendBranch-module-scss-module__YzlDOq__info_detail_item",
  "info_dt": "CardRecommendBranch-module-scss-module__YzlDOq__info_dt",
});
